module.exports = __webpack_public_path__ + "static/media/melodi-logo.3cf154f2.png";